export enum UserSettingsTab {
  PROFILE = 'My Profile',
  USERS = 'Users',
  INTEGRATIONS = 'Integrations',
  ENVIRONMENTS = 'Environments',
  DATA_ACCESS = 'Data Access',
  MCP_CONNECTIONS = 'MCP connections',
}
